<template>
    <div class="c2c-pdf-backdrop">
        <section class="c2c-pdf-viewer" role="dialog" aria-modal="true" :aria-label="document.display_filename" tabindex="-1">
            <header class="flex items-center gap-3 px-5 py-3 border-b bg-gray-100">
                <strong class="truncate flex-1 min-w-0 text-lg">{{ document.display_filename }}</strong>
            </header>
            <div class="pdf-toolbar">
                <a v-if="document.download_route" :href="document.download_route" class="pdf-button pdf-borderless"><download-icon size="18" aria-hidden="true" /> Download</a>
                <div class="pdf-edit-controls">
                    <button ref="done" type="button" @click="$emit('close')" class="pdf-button pdf-done-button">Done</button>
                </div>
            </div>
            <div v-if="isImage" class="document-image-preview">
                <img v-if="!imageError" :src="document.show_route" :alt="document.display_filename" @error="imageError = true" />
                <p v-else role="alert">This image could not be loaded. You can still download the file.</p>
            </div>
            <p v-else class="p-5" role="alert">A preview is unavailable. You can still download the file.</p>
        </section>
    </div>
</template>
<script>
import { DownloadIcon } from 'vue-feather-icons';
import { createFocusTrap } from 'focus-trap';
import { lockBackgroundScroll } from './pdf-runtime';

export default {
    components: { DownloadIcon },
    props: { document: { type: Object, required: true } },
    data() { return { imageError: false }; },
    computed: {
        isImage() { return ['jpg', 'jpeg', 'png', 'gif'].includes(String(this.document.extension || '').toLowerCase()); },
    },
    mounted() {
        this.unlockBackground = lockBackgroundScroll();
        this.trap = createFocusTrap(this.$el, { initialFocus: this.$refs.done, fallbackFocus: this.$el.querySelector('[role=dialog]'), returnFocusOnDeactivate: false, escapeDeactivates: false, allowOutsideClick: false });
        this.trap.activate();
        window.addEventListener('keydown', this.keydown);
    },
    beforeDestroy() {
        if (this.trap) this.trap.deactivate();
        if (this.unlockBackground) this.unlockBackground();
        window.removeEventListener('keydown', this.keydown);
    },
    methods: {
        canDiscard() { return true; },
        keydown(event) { if (event.key === 'Escape') { event.preventDefault(); this.$emit('close'); } },
    },
};
</script>
<style>
.document-image-preview { flex: 1; min-height: 0; overflow: auto; padding: 20px; background: #f3f4f6; }
.document-image-preview img { display: block; max-width: 100%; height: auto; margin: 0 auto; }
</style>
